// The three daily felt-alignment prompts that feed Layer 3 (Foundation
// Alignment / the Values Alignment Index). Kept in a plain module (not the
// component file) so AlignmentCheck.jsx exports only its component — and so
// the check-in flow and tests can share this config.
//
// Keys match app/models/daily_self_report.py and the POST /checkin/self-report
// contract. Each is an independent, optional 1–5 read.
export const ALIGNMENT_METRICS = [
  {
    key: "alignment_1_5",
    kicker: "Alignment",
    question: "How aligned did today feel with what matters to you?",
    low: "Off track",
    high: "Fully aligned",
  },
  {
    key: "regulation_1_5",
    kicker: "Regulation",
    question: "How settled did you feel today?",
    low: "Frazzled",
    high: "Steady",
  },
  {
    key: "presence_1_5",
    kicker: "Presence",
    question: "How present were you with what you were doing?",
    low: "Scattered",
    high: "Present",
  },
];
